function initMobileFooter() {
    const accordions = document.querySelectorAll('h2[data-parent]');
    
    accordions.forEach(accordion => {
        accordion.addEventListener('click', (e) => {
            const content = e.currentTarget.nextElementSibling;
            const isOpen = content.getAttribute('open') ?? false;
            const icon = e.currentTarget.querySelector('span');

            isOpen !== false 
            ? content.removeAttribute('open') & icon.removeAttribute('open') 
            : content.setAttribute('open', true) & icon.setAttribute('open', true);
        });
    })
}

if (window.innerWidth < 750) {
    initMobileFooter();
}
